export const CONTAINER_COMPONENT = '@recative/client-sdk/container-component';
export const BUNDLE_ID = '@recative/client-sdk/bundle-id';
export const PROFILE_ID = '@recative/client-sdk/studio-profile-id';
export const DATA_TYPE = '@recative/client-sdk/data-type';
export const DISABLE_REQUEST_EXTENSION_NAME = '@recative/client-sdk/disable-request-extension-name';
